<script>
export default {
    methods: {
        _reset() {
            Object.assign(this.$data, this.$options.data.apply(this));

            this.$children.forEach(child => {
                if('reset' in child) {
                    child.reset();
                }
            });
        },
        reset() {
            this._reset();
        }
    }
}
</script>